// extracted by mini-css-extract-plugin
module.exports = {"root":"FAQPage_root__lHt99","header":"FAQPage_header__ghtZJ","content":"FAQPage_content__i8eaP","title":"FAQPage_title__1Vmms","description":"FAQPage_description__3RE2Y"};